import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
          准备好开始探索了吗？
        </h2>
        <p className="mt-4 text-foreground-500 text-sm md:text-base max-w-lg mx-auto leading-relaxed">
          加入91网大家庭，发现更多优质内容与服务，满足你的多元需求。立即注册，开启你的探索之旅！
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-all duration-200 text-sm md:text-base whitespace-nowrap cursor-pointer"
          >
            立即加入91网
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-foreground-300 text-foreground-700 font-medium rounded-md hover:border-primary-300 hover:text-primary-500 transition-all duration-200 text-sm md:text-base whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}